import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

    pagecode: string = "notification";
    module: string = "home";
    accessdenied: boolean = false;

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {
    }
    isLoading: boolean = true;
    ngOnInit(): void {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {
                        this.accessdenied = false;

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getUserNotifications(1);
                        this.getUserRequestedConnectionList();
                        //

                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }

    requestedConnection: any[] = [];
    myRequestedConnectionShowLoading: boolean = false;
    getUserRequestedConnectionList() {
        this.myRequestedConnectionShowLoading = true;
        this.profileService.getUserRequestedConnectionList(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.requestedConnection = res.data;
                }
                this.myRequestedConnectionShowLoading = false;
            },
            (err: any) => {
                console.error("getUserRequestedConnectionList err", err);
                this.myRequestedConnectionShowLoading = false;
            }
        );
    }

    notifications: any[] = [];
    showNotificationLimit: number = 10;
    showMoreNotification() {
        this.showNotificationLimit = this.showNotificationLimit + 5;
    }
    getUserNotifications(page: any) {
        this.profileService.getUserNotifications(this.authentication._authentication.id, page).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null)
                        for (var i = 0; i < res.data.length; i++) {
                            res.data[i].createdDate = new Date(res.data[i].createdDate);
                            this.notifications.push(res.data[i]);
                        }
                    if (res.data.length > 0)
                        this.getUserNotifications(page + 1);
                    else
                        this.isLoading = false;
                }
            },
            (err: any) => {
                console.error("getUserNotifications()", err);
            }
        );

    }

    openNotification(item: any, index: any) {

        this.profileService.setNotificationAsRead(item).subscribe(
            (res: any) => {
                item.isRead = true;
                this.profileService.UnreadNotificationsCount = this.profileService.UnreadNotificationsCount - 1;
            },
            (err: any) => {
            }
        );

        if (item.relatedTo.toLowerCase() === "Connection".toLowerCase()) {
            this.router.navigate(['/profile/user-profile/' + item.relatedId]);
        }
        else if (item.relatedTo.toLowerCase() === "Instant Support".toLowerCase()) {
            //alert(item.relatedId);
            //this._router.navigate(['/support-instant-help']);
        }
        else if (item.relatedTo.toLowerCase() === "Discussion".toLowerCase()) {
            this.router.navigate(['/discussion/detail/' + item.relatedId]);
        }
        else if (item.relatedTo.toLowerCase() === "Post".toLowerCase()) {
            this.router.navigate(['/home/post/' + item.relatedId]);
        }
        else if (item.relatedTo.toLowerCase() === "SUPPORT".toLowerCase()) {
            this.router.navigate(['/support/support-case-details/' + item.relatedId]);
        }
        else if (item.relatedTo.toLowerCase() === "SDR".toLowerCase()) {
            this.router.navigate(['services/service-sdr-details/' + item.relatedId]);
        }
        else if (item.relatedTo.toLowerCase() === "Message".toLowerCase()) {
            this.router.navigate(['/profile/notificationMessage/' + item.id]);
        }
        else if (item.relatedTo.toLowerCase() === "Post_Groups".toLowerCase()) {
            this.router.navigate(['/groups/detail/' + item.relatedId]);
        }
    }

}

